import React from "react";
import { Outlet } from "react-router-dom";
import { Layout, Drawer, Button } from "antd";
import { useSelector } from "react-redux";
import "./style.css";
// import logo from "../../../config/img/logo.png";
// component
import LayoutMenu from "./layout_menu";
import LayoutFooter from "./layout_footer";

// redux
import { useDispatch } from "react-redux";
import { LogoutOutlined } from "@ant-design/icons";
import { collapseSelector } from "store/bailiff/nav/nav.selector";
import { toggleCollapse } from "store/bailiff/nav/nav.action";
import { logOut as logOutUser } from "store/user/auth/user_auth.action";

const LayoutRoot = () => {
  // -------------------------- VAR --------------------------

  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const collapsed = useSelector(collapseSelector);
  // -------------------------- EFFECT --------------------------

  // -------------------------- FUNCTION --------------------------
  const onClose = () => {
    dispatch(toggleCollapse());
  };

  const handleLogout = () => {
    dispatch(logOutUser());

    onClose();
  };

  // -------------------------- RENDER --------------------------
  const DrawerSection = () => {
    return (
      <Drawer
        closable={false}
        rootClassName="drawer-layout"
        styles={{ padding: 5, position: "relative" }}
        onClose={onClose}
        placement="left"
        width={260}
        open={collapsed}
      >
        <div className="logo">
          <div
            style={{
              minHeight: 60,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              fontSize: 20,
            }}
          >
            Dịch Vụ Chuyển Âm
          </div>
        </div>
        <LayoutMenu />
        <div
          style={{
            position: "absolute",
            bottom: 10,
            left: 0,
            right: 0,
            minHeight: 50,
            textAlign: "center",
          }}
        >
          <Button onClick={handleLogout} icon={<LogoutOutlined />}>
            Đăng Xuất
          </Button>
        </div>
      </Drawer>
    );
  };
  // -------------------------- MAIN --------------------------

  return (
    <Layout>
      <DrawerSection />
      <Layout>
        <Outlet />
        <LayoutFooter />
      </Layout>
    </Layout>
  );
};

export default LayoutRoot;
